import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AsyncPaginate } from "react-select-async-paginate";
import { useFilters } from '../../containers/filter/_redux/slice';
import {
    recursiveGetElementsByKey,
    recursiveGetIds
} from '../../helpers/three';
import _ from "lodash";
import buildQuery from 'odata-query'
import { getUserFactoryId } from '../../../index';
import api from '../../services/api';

export function SelectAsyncPaginateStandards ({ structureId = null, standardType, onChangeCallback}){
    
    const { struct } = useFilters();

    const [ filterState, setFilters ] = useState({
        standardType: standardType,
        structureId: structureId
    })
    
    const [ selected, setSelected ] = useState({
        id:0,
        name: '',
        identifier: ''
    })
    
    useEffect(() => {
        if(structureId) {
            const selectedNodes = recursiveGetElementsByKey(structureId, struct.tree, []);
            const ids = recursiveGetIds(selectedNodes, []);
            const idArray = ids.length == 0 ? [structureId] : ids
            setFilters(
                {
                    standardType: standardType,
                    structureId: idArray
                }
            ) 
            console.log(idArray)
        }
        else
        {
            setFilters(
                {
                    standardType: standardType,
                    structureId: []
                }
            ) 
        }
        setSelected({
            id:0,
            name:'',
            identifier:''
        })
    }, [structureId, standardType]);

    const loadOptions = async (searchQuery, loadedOptions, { page }) => {
       
        let filter = {
            or: [
                { 'structure/factoryId': { eq: parseInt(getUserFactoryId()) } },
                { 'structure/factoryId': { eq: 1207 } },
            ],
            status: 'Official',
            version: { gt: 0 }
        }
        
        if (_.has(filterState, 'structureId') && !_.isEmpty(filterState.structureId)) {
            console.log(filterState.structureId)
            filter = _.merge(filter, {
                structureId: {
                    in: _.get(filterState, 'structureId')
                }
            })
        }

        if (searchQuery.length > 0) {
            filter = _.merge(filter, {
                name : {
                    contains: searchQuery
                }
            })
        }
        console.log(structureId)
        console.log(filterState.structureId)
        console.log(filter)

        const response = await fetchDataByOdata(filterState.standardType.toLowerCase(), 
        {
            filter,
            top: 10,
            skip: (page - 1) * 10,
            select: ['name', 'id', 'identifier'],
            orderBy: ['Name asc'],
            count: true            
        })

        if ( response.status !== 200 ) {
            console.log(response.error);
            return
        }
        
        return {
            options: response.data.value,
            hasMore: response.data._count > page * 10,
            additional: {
                page: page + 1,
            },
        };
    };

    function fetchDataByOdata ( filterType, odata ) {
        return api.get(`${filterType}/odata${buildQuery(odata)}`)
    }

    const onChange = (option) => {
        if (typeof onChangeCallback === "function") {
            onChangeCallback(option);
        }
        setSelected(option);
    };

    return (
        <AsyncPaginate
            //defaultOptions
            key={JSON.stringify(filterState)}
            value={selected || ""}
            loadOptions={loadOptions}
            getOptionValue={(option) => option.name}
            getOptionLabel={(option) => option.name}
            onChange={onChange}
            isSearchable={true}
            placeholder=""
            debounceTimeout={500}
            additional={{
                page: 1,
            }}
        />
    );
};
